import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=1fb603a1&"
import script from "./AppLogo.vue?vue&type=script&lang=js&"
export * from "./AppLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb603a1')) {
      api.createRecord('1fb603a1', component.options)
    } else {
      api.reload('1fb603a1', component.options)
    }
    module.hot.accept("./AppLogo.vue?vue&type=template&id=1fb603a1&", function () {
      api.rerender('1fb603a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/General/Header/AppLogo.vue"
export default component.exports